import { Component } from '@angular/core';
import { saveAs } from 'file-saver';
import { ReportsService } from '../../../../services/reports.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TableModule } from 'primeng/table';
import { CommonService } from '../../../../services/common.service';

@Component({
    selector: 'app-find-tlr-given-workorder',
    imports: [TableModule, CommonModule, FormsModule, RouterModule],
    templateUrl: './find-tlr-given-workorder.component.html',
    styleUrl: './find-tlr-given-workorder.component.scss'
})
export class FindTlrGivenWorkorderComponent {

  constructor(private report: ReportsService,
    public commonService: CommonService
  ) { }
  trlWorkOrderNumber: any;
  orderNumber: string = '';
  showTable: boolean = false;
  facilityID: string = ''
  isLoading: boolean = false;


  ngOnInit() {
    this.facilityID = localStorage.getItem('current_facility_id') || 'ES';
  }

  searchTag() {
    if(this.orderNumber) {
      this.getTLRsForGivenorderNumber('ES', this.orderNumber, this.commonService.getUserCai());
    }
  }

  getTLRsForGivenorderNumber(facilityId: string, workOrder: string, userCAI: string): void {
    this.isLoading = true;
    this.report.getTLRGivenWorkOrderReport(facilityId, workOrder, userCAI).subscribe(
      (data: any) => {
        this.trlWorkOrderNumber = data;
        this.isLoading = false;
        this.showTable = true;
      },
      (error: any) => {
        this.isLoading = false;
        console.error('Error fetching TLRs for given work order:', error);
      }
    );
  }
  

  exportToExcel() {
    const params = {
      facilityId: localStorage.getItem('current_facility_id') || 'ES',
      workOrder: this.orderNumber, // assuming orderNumber holds the work order number
      cai: this.commonService.getUserCai()
    };
  
    this.report.getTLRGivenWorkOrderReportExcel(params).subscribe({
      next: (fileData: any) => {
        if (fileData) {
          saveAs(fileData, `WorkOrder_${params.workOrder}.xlsx`);
        }
      },
      error: (err: any) => {
        console.error('Error fetching report details:', err);
      }
    });
  }
  
}


